<template>
    <div class="c-accordion">
        <div class="c-accordion__item"  :class="{'is-active': open}">
            <div class="c-accordion__content">
                <slot></slot>
            </div>
            <a href="#" class="fs-small" @click.prevent="toggle" v-if="!open">{{linktext}}</a>
            <a href="#" class="fs-small" @click.prevent="toggle" v-if="open">Minder tonen</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        linktext: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        close() {
            this.open = false;
        }
    }
}
</script>
